import Vue from 'vue'
import App from './App.vue'
import router from './store/router'
import axios from 'axios'
import store from './store'
import 'bootstrap/dist/css/bootstrap.css'
import './assets/theme.css'

Vue.config.productionTip = true
Vue.prototype.$http = axios

// Legacy client-side token-expiry check. Skipped when using the API auth, where
// token expiry is enforced server-side (Sanctum) and a 401 clears the session
// via the http.js interceptor — otherwise the missing `dateTorken` would log
// API-authenticated users out on every reload.
const USE_API_AUTH = process.env.VUE_APP_USE_API_AUTH === 'true'
if (!USE_API_AUTH) {
    const current_date_time = new Date().getTime()
    if (localStorage.getItem('access_token') != null && localStorage.getItem('userType') != 'viewer') {
        if (localStorage.getItem('dateTorken') < current_date_time) {
            localStorage.setItem('access_token', '')
            store.dispatch('destroyToken')
        }
    }
}
// console.log(auth_data)
new Vue({
  axios,
  router,
  store,
  render: h => h(App),
}).$mount('#app')